/**
 * CRM user departments
 */

export const USER_DEPARTMENTS = {
    sales: 'Sales',
    marketing: 'Marketing',
    engineering: 'Engineering',
    qa: 'QA',
    devops: 'DevOps',
    ai: 'AI',
    customer_success: 'Customer Success',
    hr: 'HR',
    finance: 'Finance',
    management: 'Management'
};

export const USER_DEPARTMENT_ORDER = Object.keys(USER_DEPARTMENTS);
